<script setup lang="ts">
/**
 * 공통 Signers 블록 ([[Signers]] 재현) — 실제 서명자 선택 UI (OtcSigners 미러링).
 * varKey 'dcr' = 이사 전원 / 'waiver' = 기존 주주 전원 (패널이 directors/waiverMembers 배열과 브리지).
 * (Resignation 이 쓰는 SignersField 재사용.)
 */
import { computed, inject } from 'vue';
import { TRANSFER_DOC_CTX } from '../transferContext';
import SignersField from '../../resignation/signers/SignersField.vue';
import type { SignerEntry } from '@/features/AI-documents/types/docGen.types';

const props = withDefaults(defineProps<{ varKey: string; boardLabel?: string }>(), { boardLabel: '' });
const ctx = inject(TRANSFER_DOC_CTX)!;
const signers = computed(() => ctx.signersOf(props.varKey));
function onUpdate(list: SignerEntry[]) { ctx.setSigners(props.varKey, list); }
// 자동 입력 버튼 — 서명란이 비어있고 소스 데이터가 있을 때만 (현재 Waiver = 기존 주주 − 매도자).
const showAutofill = computed(() => signers.value.length === 0 && ctx.canAutofillSigners(props.varKey));
</script>

<template>
  <div>
    <button v-if="showAutofill" type="button" class="trf-autofill" @click="ctx.autofillSigners(varKey)">
      <span class="ai">✨</span> Auto-fill signers — existing members (excluding the seller)
    </button>
    <SignersField
      :model-value="signers"
      :board-label="boardLabel"
      :var-key="varKey"
      :entity-cd="ctx.entityCd.value"
      @update:model-value="onUpdate"
    />
  </div>
</template>

<style scoped>
.trf-autofill { display:inline-flex; align-items:center; gap:6px; margin-bottom:10px; border:1px solid #cfe0ff; background:#f0f6ff; color:#1B64DA; font-weight:700; font-size:12px; border-radius:8px; padding:6px 12px; cursor:pointer; }
.trf-autofill:hover { background:#e2eeff; }
.trf-autofill .ai { font-size:12px; }
</style>
